<div class="flex flex-column consult__section consult__organ">
  <div class="col-12 inline-flex consult__section-subheading-group flex-wrap">
    <h3 class="col-12 inline-flex align-items-center lg:col-8 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer"
        for="organ_{{mainDetail?.id}}">{{screen.labels.odonto.history.heading}}</label>
    </h3>
    <span class="col-12 lg:col-4 consult__section-help">{{screen.labels.odonto.history.help}}</span>
  </div>

  <div class="inline-flex flex-column col-12 p-0 mt-2" *ngIf="mainDetail && expandSection">
    <textarea pInputTextarea name="organ_{{mainDetail.id}}" [(ngModel)]="mainDetail.details" [rows]="4"
      class="uppercase m-0" validation></textarea>

    <small class="py-2">
      {{screen.labels.odonto.disclaimer}} {{catalogsName}}
    </small>

    <div class="mt-2 align-self-end">
      <p-button [label]="screen.labels.odonto.showDetail" (onClick)="showDetails = true"></p-button>
    </div>
  </div>

  <div hidden>
    <div *ngFor="let catalog of catalogs">
      <ms-odonto-catalog-item [catalog]="catalog" [readonly]="readonly">
      </ms-odonto-catalog-item>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="showDetails" position="right" [blockScroll]="true" appendTo="body"
  [style]="{ width: '425px', maxWidth: '90%' }">
  <div class="inline-flex flex-column">
    <h3 class="text-base font-normal mb-2">
      {{screen.labels.odonto.detailDescription}}
    </h3>

    <div *ngFor="let catalog of catalogs">
      <ms-odonto-catalog-item [catalog]="catalog" [turn]="turn" [readonly]="readonly"
        (catalogChange)="handleUpdateGlobalField($event)">
      </ms-odonto-catalog-item>
    </div>
  </div>
</p-sidebar>